import * as util from './util';
import CONST from './const';
import logger from './logger';
import fileUtil from './fileUtil';
import encryptor from './encrypt';
import Deferred from './lib/Deferred';
import * as websocket from './websocket';

const URL = `${location.protocol}//${util.getHost()}/webapp/json/sliceUpload/`;
const fragmentCMD = ['FileUpload', 'FileUploadVoice', 'FileUploadVideo', 'FileUploadTouchuan'];

/**
 * 打包数据包，返回 JSON
 */
function makeFragmentInfo(info) {
  info = util.extend(
    true,
    {
      uin: `${util.getUin()}`,
      appid: 'circle_video',
      session: '',
      offset: 0,
      data: '',
      checksum: '',
      check_type: CONST.CHECK_TYPE_MD5,
    },
    info,
  );

  return info;
}

/**
 * 打包数据包，返回 FormData
 */
function makeFragmentAsFormData(info) {
  let fragmentInfo = makeFragmentInfo(info);
  let flatInfo = util.flatObj(fragmentInfo);

  let formData = new FormData();

  for (let key in flatInfo) {
    formData.append(key, flatInfo[key]);
  }

  return formData;
}

/**
 * 打包控制包
 */
function makeControlInfo(file, info, sha) {
  let token;

  if (util.domain.qq && !util.domain.qzone) {
    token = {
      type: 3,
      data: util.cookie('skey'),
    };
  } else {
    token = {
      type: 4,
      data: util.cookie('p_skey'),
      appid: 5,
    };
  }

  info = util.extend(
    true,
    {
      uin: `${util.getUin()}`,
      token: token,
      appid: 'circle_video', //pic_qzone, video_qzone, 其它的用不到忽略
      checksum: sha.hash, //照片sha
      check_type: CONST.CHECK_TYPE_MD5, //0-md5校验, 1-sha校验
      file_len: file.size, //照片大小
      env: {
        refer: 'pccircle',
        deviceInfo: 'h5',
        source: 5,
      },
      model: 0, //上传模型, 0-普通上传, 1-预上传
      biz_req: {
        //图片数据
        sPicTitle: file.name, //照片名
        sPicDesc: '', //描述
        sAlbumName: '', //相册名称
        sAlbumID: '', //相册ID
        iAlbumTypeID: 0, //相册类型ID
        iBitmap: 0, //分享同步设置(最低位为1表示同步腾讯微博)
        iUploadType: 3, //上传类型 0 普通上传 1 大图 1200规格 2 高清 1600规格 3 原图上传
        iUpPicType: 0, //上传类别 0 表示单张上传 1表示多图上传
        iBatchID: 0, //每次上传唯一ID
        sPicPath: '', //图片在手机里面的绝对路径，必须填写，以此区别同样图片上传
        iPicWidth: 0, //图片宽
        iPicHight: 0, //图片高
        iWaterType: 0, //是否打印水印，1打印 0不打印
        iDistinctUse: 0, //上传区分，相册 说说 日志等
      },
      session: '', //断点续传时填
      asy_upload: 0, //上传方式, 0-同步上传, 1-异步上传
      // 'slice_size': 16 * 1024
    },
    info,
  );

  return info;
}

/**
 * 控制包
 */
function controlPacker(file, info, hash) {
  let defer = new Deferred();
  let startTime = Date.now();

  hash = hash || { hash: '' };

  logger.log('controlPacker request');

  let controlReq = makeControlInfo(file, info, hash);

  // skey 或 pskey 没有登陆态直接拒了
  if (
    (controlReq.token.type === 3 || controlReq.token.type === 4) &&
    controlReq.token.data === undefined
  ) {
    defer.reject({
      ret: CONST.REPORT.FILE_UPLOAD_TOKEN_ERROR,
      msg: 'token error, no skey or pskey',
    });

    util.report007(
      'FILE_BATCH_CONTROL_WEBSOCKET',
      2,
      CONST.REPORT.FILE_UPLOAD_TOKEN_ERROR,
      Date.now() - startTime,
    );

    return defer;
  }

  //发送控制包
  request({
    cmd: 'FileBatchControl/' + hash.hash,
    info: {
      control_req: [controlReq],
    },
  })
    .done(control => {
      defer.resolve(control);
    })
    .fail(result => {
      defer.reject(result);
    })
    .always((result = {}) => {
      console.log('222222222222result', result);
      if (result.ret === CONST.REPORT.REQUEST_ERROR && result.subret === 0) {
        logger.log('[error] FileBatchControl cors host: ' + location.host, true);
      }

      util.report007(
        result.type === 'websocket' ? 'FILE_BATCH_CONTROL_WEBSOCKET' : 'FILE_BATCH_CONTROL_NORMAL',
        result.ret !== 0 ? 1 : 0,
        result.subret || result.ret,
        Date.now() - startTime,
      );
    });

  return defer;
}

/**
 * 数据上传
 */
function uploadFile(option) {
  let defer = new Deferred(),
    startTime = Date.now(),
    file = option.file,
    info = option.info,
    onProcess = option.onProcess,
    slice_size = info.slice_size,
    offset = info.offset,
    queue = [],
    channel = 0,
    limit = websocket.support() ? util.getWebsocketLimit : util.getUploadLimit, // 限制并行上传分片数
    maxRetry = 5, // 每片最多重试次数
    total = 0,
    end,
    sliceTotal = Math.ceil((file.size - offset) / slice_size),
    sliceSeq = 0,
    sliceReceived = 0;

  logger.log('upload fragment start');

  do {
    end = Math.min(offset + slice_size, file.size);
    info.offset = offset;
    uploadFragment(
      util.extend(
        true,
        {
          offset: offset,
          retry: 0,
          seq: sliceSeq++,
          end: end,
        },
        info,
      ),
    ); // 这里需要深拷贝
    offset = end;
  } while (end < file.size); // 还有剩余分片就继续上传

  // 分片上传
  function uploadFragment(fragmentInfo) {
    // 文件转 base64
    fileUtil
      .readerFileAsBlob(file, fragmentInfo.offset, fragmentInfo.end)
      .done(base64 => {
        fragmentInfo.data = base64;

        if (channel < limit) {
          channel++;
          // 发送数据包
          uploadData(fragmentInfo);
        } else {
          queue.push(fragmentInfo);
        }
      })
      .fail((result = {}) => {
        logger.log(`upload fragment slice error ret: ${result.ret}`);
        defer.reject(result);
      });
  }

  function uploadData(fragmentInfo) {
    let fragmentStartTime = Date.now();
    logger.log(`upload fragment uploadData`);

    //发送数据包
    request({
      cmd: fragmentInfo.cmd || 'FileUpload',
      tail:
        '?seq=' +
        fragmentInfo.seq +
        '&retry=' +
        fragmentInfo.retry +
        '&offset=' +
        fragmentInfo.offset +
        '&end=' +
        fragmentInfo.end +
        '&total=' +
        file.size,
      info: makeFragmentInfo(fragmentInfo),
    })
      .done(result => {
        logger.log(`upload fragment uploadData done ret: ${result.ret}`);
        /**
         * result.flag：
         * 0,  // 单次请求成功，继续下一分片上传
         * 1,  // 上传已经全部完成
         * 2,  // 图片已经传完,需要确认，客户端判断的标识，web不用管
         * 10, // 不可重试错误,直接给用户显示错误
         * 11, // 后台接口波动,重试当前包
         * 12, // 后台接口波动,重发带session的控制包断点续传
         * 13, // 后台缓存数据有问题,重发空session的控制包
         * 14, // 后台缓存数据有问题,长连接时断开重连
         */
        if (result.flag === 0) {
          //上传完一个分片，等待其它分片完成
          receiveSlice();
          channel--;
          total = Math.min(total + slice_size, file.size - 1); //减1是为了保证上传进度在100%以下
          onProcess({ step: 3, uploaded: total, total: file.size });
          //还有其它分片在队列中，就拿出来继续上传
          if (queue.length && channel < limit && file.active) {
            channel++;
            //发送数据包
            uploadData(queue.shift());
          }
        } else if (result.flag === 1) {
          //所有分片上传完成
          receiveSlice(true);
          onProcess({ step: 4, uploaded: file.size, total: file.size });
          defer.resolve({
            ret: 0,
            msg: 'file upload success',
            file: option.file,
            info: option.info,
            biz: result.biz || {},
          });
        } else if (result.flag === 10) {
          receiveSlice(true);
          onProcess({ step: 5, uploaded: total, total: file.size });
          defer.reject({
            ret: CONST.REPORT.UPLOAD_FRAGMENT_BACKEND_ERROR,
            msg: 'upload fragment backend error',
            info: result,
          });
        } else if (result.flag === 11 || fragmentInfo.retry < maxRetry) {
          fragmentInfo.retry++;
          uploadData(fragmentInfo);
        } else {
          receiveSlice(true);
          defer.reject(result);
        }
      })
      .fail((result = {}) => {
        logger.log(
          `upload fragment fail, ret: ${result.ret}, subret: ${
            result.subret
          }, flag: ${(result.info && result.info.flag) || -1}`,
        );
        if (
          fragmentInfo.retry < maxRetry &&
          result.info.flag !== 10 &&
          result.info.flag !== 12 &&
          result.info.flag !== 13
        ) {
          fragmentInfo.retry++;
          uploadData(fragmentInfo);
        } else {
          receiveSlice(true);
          defer.reject(result);
        }
      })
      .always((result = {}) => {
        if (result.ret === CONST.REPORT.REQUEST_ERROR && result.subret === 0) {
          logger.log(
            '[error] FileUpload cors host: ' + location.protocol + '//' + location.host,
            true,
          );
        }
        // 每片的上报
        util.report007(
          result.type === 'websocket'
            ? `FILE_UPLOAD_WEBSOCKET_${util.getWebsocketLimit}`
            : util.supportFormData()
            ? 'FILE_UPLOAD_FORMDATA'
            : 'FILE_UPLOAD_NORMAL',
          result.ret !== 0 ? 1 : 0,
          result.subret || result.ret,
          Date.now() - fragmentStartTime,
        );
      });
  }

  function receiveSlice(ended) {
    sliceReceived++;

    if (sliceReceived >= sliceTotal && !ended) {
      onProcess({ step: 5, uploaded: total, total: file.size });
      defer.reject({
        ret: CONST.REPORT.ALL_FRAGMENT_SUCC_BUT_NOT_END,
        msg: 'all fragment success but not end',
        info: info,
      });
    }
  }

  return defer.always((result = {}) => {
    // 本次上传的最终上报
    util.report007(
      websocket.support()
        ? `FILE_UPLOAD_DONE_WEBSOCKET_COUNT_${util.getWebsocketCount}_LIMIT_${util.getWebsocketLimit}` ||
            'FILE_UPLOAD_DONE_WEBSOCKET'
        : util.supportFormData()
        ? `FILE_UPLOAD_DONE_FORMDATA_${util.getUploadLimit}`
        : 'FILE_UPLOAD_DONE_NORMAL',
      result.ret !== 0 ? 1 : 0,
      result.subret || result.ret,
      Date.now() - startTime,
    );
  });
}

/**
 * 发送请求
 */
function request(option) {
  let defer = new Deferred();

  option.g_tk = util.getToken();

  logger.log('websocket send start');
  console.log('++++++++', option);

  websocket
    .send(util.extend(true, {}, option))
    .done((result = {}) => {
      // 逻辑错误也是 send 成功
      console.log('---------', result);
      if (result.ret === 0 && result.data && result.data.ret === 0) {
        defer.resolve(util.extend(false, result.data, { type: 'websocket' }));
      } else {
        defer.reject({
          ret: CONST.REPORT.WEBSOCKET_RET_CODE_ERROR,
          msg: `${option.cmd} ret code error`,
          info: result && result.data ? result.data : result,
          subret: result.ret,
          type: 'websocket',
        });
      }
    })
    .fail(res => {
      // websocket error 才用 xhr
      if (util.supportFormData() && fragmentCMD.indexOf(option.cmd) !== -1) {
        logger.log('formdata send start');

        try {
          // 链接上加个类型，定位问题用
          option.tail += (option.tail.indexOf('?') > -1 ? '&' : '?') + 'type=form';
        } catch (error) {}

        option.info = makeFragmentAsFormData(option.info);
        xhr(option)
          .done(defer.resolve)
          .fail(defer.reject);
      } else if (fragmentCMD.indexOf(option.cmd) !== -1) {
        logger.log('json send start');

        try {
          // 链接上加个类型，定位问题用
          option.tail += (option.tail.indexOf('?') > -1 ? '&' : '?') + 'type=json';
        } catch (error) {}

        fileUtil.blobToBase64(option.info.data).done(base64 => {
          option.info.data = base64;
          xhr(option)
            .done(defer.resolve)
            .fail(defer.reject);
        });
      } else {
        // control request
        xhr(option)
          .done(defer.resolve)
          .fail(defer.reject);
      }
    });

  return defer;
}

function xhr(option) {
  let defer = new Deferred();
  let xmlhttp = new XMLHttpRequest();
  let url = URL + option.cmd + (option.tail || '');
  let timeout = 20000;
  let result;

  url += (url.indexOf('?') > -1 ? '&' : '?') + 'g_tk=' + option.g_tk;

  xmlhttp.addEventListener('timeout', e => {
    defer.reject({
      ret: CONST.REPORT.REQUEST_TIMEOUT,
      msg: `${option.cmd} timeout ${timeout}`,
      type: 'xhr',
    });
  });

  xmlhttp.addEventListener('readystatechange', e => {
    if (xmlhttp.readyState != 4) return;

    if (xmlhttp.status == 200) {
      try {
        result = JSON.parse(xmlhttp.responseText);
      } catch (error) {
        defer.reject({
          ret: CONST.REPORT.PARSE_RESEPONSE_JSON_ERROR,
          msg: `${option.cmd} parse response json error`,
          type: 'xhr',
        });

        return;
      }

      if (result.ret === 0 && result.data && result.data.ret === 0) {
        defer.resolve(util.extend(false, result.data, { type: 'xhr' }));
      } else {
        defer.reject({
          ret: CONST.REPORT.RET_CODE_ERROR,
          msg: `${option.cmd} ret code error`,
          info: result && result.data ? result.data : result,
          subret: result.ret, // md 上报用
          type: 'xhr',
        });
      }
    } else {
      let errorInfo = {
        ret: CONST.REPORT.REQUEST_ERROR,
        msg: `${option.cmd} request error`,
        info: {
          status: xmlhttp.status,
          readyState: xmlhttp.readyState,
          statusText: xmlhttp.statusText,
          responseURL: xmlhttp.responseURL,
        },
        file: option.file,
        subret: xmlhttp.status, // md 上报用
        type: 'xhr',
      };

      defer.reject(errorInfo);
      logger.log(JSON.stringify(errorInfo));
    }
  });

  xmlhttp.open('POST', url);
  xmlhttp.timeout = timeout;
  !util.isSameOrigin(url) && (xmlhttp.withCredentials = true);

  if (util.supportFormData() && option.info instanceof window.FormData) {
    xmlhttp.send(option.info);
  } else {
    xmlhttp.setRequestHeader('Content-Type', 'application/json');
    xmlhttp.send(JSON.stringify(option.info));
  }

  return defer;
}

/**
 * -------------------------------- encrypt start ---------------------------------
 */
function encrypt(file, encryptMethod, onProgress) {
  let defer = new Deferred();
  let deferList = [];

  encryptMethod = encryptMethod || 'md5';

  if (util.isString(encryptMethod)) {
    encryptMethod = [encryptMethod];
  }

  encryptMethod.forEach(method => {
    let encryptDefer = new Deferred();
    let hashResult = {};

    if (file[method] || file.hash) {
      hashResult[method] = file[method] || file.hash;
      encryptDefer.resolve(hashResult);
    } else {
      encryptor.encrypt(file, {
        type: method,
        onProgress: function(progress) {
          onProgress && onProgress(Math.floor(progress));
        },
        onResult: function(hash) {
          hashResult[method] = hash;
          encryptDefer.resolve(hashResult);
        },
        onError: function(err) {
          encryptDefer.reject({
            ret: err.ret || CONST.REPORT.ENCRYPT_ERROR,
            msg: err.message || 'encrypt error',
            info: err.info,
            file: file,
          });
        },
      });
    }

    deferList.push(encryptDefer);
  });

  Deferred.when
    .apply(null, deferList)
    .done(function() {
      let args = arguments;
      let result = {
        file: file,
      };
      let item;

      for (let i = 0, len = args.length; i < len; i++) {
        item = args[i];
        if (util.isArray(item)) {
          item = (item && item[0]) || {};
        }
        util.extend(false, result, item);
        util.extend(false, result.file, item);
      }

      // 只有一个 hash 类型的时候，兼容老逻辑 result 和 file 都有 hash 值
      if (encryptMethod.length === 1) {
        result.hash = result.file.hash = result[encryptMethod[0]];
      }

      defer.resolve(result);
    })
    .fail(function(res) {
      defer.reject(res);
    });

  return defer;
}

/**
 *  -------------------------------- encrypt end ---------------------------------
 */

export default {
  controlPacker,
  uploadFile,
  encrypt,
};
